import { html, type TemplateResult } from '@design.estate/dees-element';
import type { DeesAppuiBar } from './component.js';

export const renderAppuiAppbar = (component: DeesAppuiBar): TemplateResult => {
      return html`
        <div class="menus">
          ${component.showWindowControls ? html`<dees-windowcontrols></dees-windowcontrols>` : ''}
          ${component.renderMenuItems()}
        </div>
        <div class="breadcrumbs">
          ${component.renderBreadcrumbs()}
        </div>
        <div class="account">
          ${component.renderAccountSection()}
        </div>
      `;
  
};
